import React from 'react';
import { useIntl } from 'react-intl';
import HomeLink from '../HomeLink';
import LinkAndAnchor from '../LinkAndAnchor';
import messages from '../../lib/messages.json';

const Breadcrumbs = () => {
  const intl = useIntl();

  return [
    <HomeLink />,
    <LinkAndAnchor
      route="markets"
    >
      {intl.formatMessage(messages['markets.title'])}
    </LinkAndAnchor>,
  ];
};

export default Breadcrumbs;
